import { useCallback } from 'react'

import { useStockDividendsSearch } from '@pages/Traders-Room/Stock-Dividends/hooks/useStockDividendsSearch'

import { useSessionLanguage } from '@context/SessionSettingsContext'

import { PageQuery, useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { useFetchAppendablePage } from '@hooks/useFetch'

export const useStockDividendsFetch = (searchState: ReturnType<typeof useStockDividendsSearch>) => {
  const apiClient = useApiClient(ClientApiClient)
  const locale = useSessionLanguage()

  const callback = useCallback(
    async (query?: PageQuery) => {
      return await apiClient.getCorporateActions({
        ...query,
        ...searchState.search,
        ca_search_Type: 1,
        ca_search_GrossDividendAmountFrom: 0.01,
        ca_search_TextSearch: searchState.debouncedSearchTerm || undefined,
      })
    },
    [apiClient, locale, searchState.debouncedSearchTerm, searchState.search]
  )

  return useFetchAppendablePage(callback)
}
